<template>
    <svg class="won-color-gray stroke-2 w-4 h-4" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2448_34492)">
            <path d="M13.5 5.25H11.625L14.25 2.625L16.875 5.25H15V12.75H16.875L14.25 15.375L11.625 12.75H13.5V5.25ZM10.5 3.75V5.25H1.5V3.75H10.5ZM10.5 14.25H1.5V12.75H10.5V14.25ZM10.5 9.75H1.5V8.25H10.5V9.75Z" fill="#444C58"/>
        </g>
        <defs>
            <clipPath id="clip0_2448_34492">
                <rect width="18" height="18" fill="white" transform="matrix(-1 0 0 1 18 0)"/>
            </clipPath>
        </defs>
    </svg>
</template>

<style scoped>

</style>
